// extracted by mini-css-extract-plugin
export var completionBody = "_jy-2";
export var completionCard = "_jy-0";
export var completionFooter = "_jy-3";
export var completionTitle = "_jy-1";